export default {
  allMsg: 'All messages',
  systemMsg: 'System messages',
  personMsg: 'Manual messages',
  unread: 'Unread',
  seeDetail: 'See Details',
  read: 'Read',
  replyNow: 'reply now',
  message: 'Message',
  operateSuccess: 'Operate successfully',
  holder: {
    searchHolder: 'Package No./Order No./Item No.',
  },
  addAcBuy: 'Join AcBuy Discord & Win ¥2000 CASH!',
  joinNow: 'Join Here',
  flatActivity: 'Share How You Shop on Taobao & AcBuy — Win ¥1500 CASH!',
  joinNow1: 'Join Now',
  tips1: 'Acbuy Official Labubu Giveaway',
  tips2: 'Huge Labubu Giveaway &  Full ZIMOMO Set',
}
